export enum RemoveRequiredFieldsTypes {
    DeduCase = "dedu_case",
}

export enum DeduRemoveFieldsTypes {
    ProfessionID = "profession_id",
    TaskpriorityID = "taskpriority_id",
    TasktypeID = "tasktype_id",
}
